module.exports = __webpack_public_path__ + "img/dt-logo-white-text.cd4c1ae1.svg";